import React from "react";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import StyledImage from "../StyledImage/StyledImage";
import { useWindowSize } from "../../helpers/useWindowSize";
import styles from "./CategoryCard.module.scss";
import { DataLayerConfig } from "../../helpers/GoogleTagManager/types/DataLayerConfig";
import { gtmCustomLinkEvent } from "../../helpers/GoogleTagManager/dataLayerEvents";
import { CustomLinkEvent } from "../../helpers/GoogleTagManager/types/CustomLinkEvent";
import { ProductCategory } from "../../helpers/GoogleTagManager/types/ProductCategory";

interface CategoryCardProps {
    imageURL: string;
    imageAltText: string;
    backgroundGraphicURL: string;
    backgroundShadow?: "drop-shadow" | "peel-shadow" | undefined;
    title: ProductCategory | string;
    cardColor: string;
    buttonColor: string;
    buttonHoverColor: string;
    buttonLink: string;
    dataLayerConfig?: DataLayerConfig;
}

const CategoryCard: React.FC<CategoryCardProps> = ({
    imageURL,
    imageAltText,
    backgroundGraphicURL,
    backgroundShadow,
    title,
    cardColor,
    buttonColor,
    buttonHoverColor,
    buttonLink,
    dataLayerConfig,
}) => {
    const { width: windowWidth } = useWindowSize();

    return (
        <article
            className={styles.cardContainer}
            style={{ backgroundColor: cardColor }}
        >
            <div className={styles.imageContainer}>
                <img
                    className={styles.backgroundGraphic}
                    src={backgroundGraphicURL}
                    alt=""
                    width={300}
                    height={300}
                />
                <a
                    className={styles.imageLink}
                    href={buttonLink}
                    onClick={() => {
                        gtmCustomLinkEvent(
                            CustomLinkEvent.IMAGE_CLICK,
                            dataLayerConfig
                        );
                    }}
                >
                    <StyledImage
                        imageURL={imageURL}
                        altText={imageAltText}
                        aspectRatio="1/1"
                        maxWidth="280px"
                        backgroundShadow={backgroundShadow}
                        imageAboveFold={true}
                    />
                </a>
            </div>
            <div>
                <a
                    className={styles.cardTitleLink}
                    href={buttonLink}
                    onClick={() => {
                        gtmCustomLinkEvent(
                            CustomLinkEvent.TEXT_CLICK,
                            dataLayerConfig
                        );
                    }}
                >
                    <h2 className={styles.cardTitle}>{title}</h2>
                </a>
                <div className={styles.btnContainer}>
                    <PrimaryButton
                        text="View Full Range"
                        link={buttonLink}
                        size={
                            windowWidth && windowWidth >= 768
                                ? "medium"
                                : "small"
                        }
                        buttonColor={buttonColor}
                        hoverColor={buttonHoverColor}
                        dataLayerConfig={dataLayerConfig}
                    />
                </div>
            </div>
        </article>
    );
};

export default CategoryCard;
